<template>
  <div class="container">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>会员卡详情</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>
    <!-- <button>logs</button> -->
    <div class="carddetail_total_height">
      <div v-show="loaded">
        <div class="bb_cardDetail">
          <div class="bb_cardDetail_block">
            <!-- <img v-if="mycardeatil.thumb==null||mycardeatil.thumb==''" src="../../assets/images/base/fixedCard.png"> -->
            <img :src="mycardeatil.thumb" />
            <div class="bb_cardDetail_block_item_block">
              <div class="bb_cardDetail_block_item_block_title">&nbsp;</div>
              <div class="bb_cardDetail_block_item_block_mg3">
                {{mycardeatil.msg_3}}
              </div>
              <div class="bb_cardDetail_block_item_block_mg1">
                {{mycardeatil.msg_1}}
                <div>{{mycardeatil.end_dateM}} 到期</div>
              </div>
              <div class="bb_cardDetail_block_item_block_mg2">
                {{mycardeatil.msg_2}}
                <div>NO.&nbsp;&nbsp;{{mycardeatil.cards_no}}</div>
              </div>
            </div>
          </div>
        </div>

        <div v-show="benefit_status" @click="tologs()" class="bb_cardRightDetail">
          <img class="bb_cardRightDetail_icon" src="../../assets/images/base/right_icon.png" />
          权益使用明细
          <img class="bb_cardRightDetail_to" src="../../assets/images/base/right_to.png" />
        </div>

        <div class="m_container_fluid" v-if="mycardeatil.type==3">
          <div class="m_container card_quanyi">
            <ul>
              <li @click="showVipBenefit(0)" v-if="mycardeatil.total_fee==888">
                <div>
                  <img src="../../assets/images/base/free_12times.png">
                  <p>获赠免费次数</p>
                </div>
              </li>
              <li @click="showVipBenefit(0)" v-else-if="mycardeatil.total_fee==2888">
                <div>
                  <img src="../../assets/images/base/free_52times.png">
                  <p>获赠免费次数</p>
                </div>
              </li>
              <li @click="showVipBenefit(0)" v-else>
                <div>
                  <img src="../../assets/images/base/nofree_times.png">
                  <p class="card_quanyi_single_p">获赠免费次数</p>
                </div>
              </li>
              <li v-for="(item,index) in icolists" @click="showVipBenefit(index+1)" :key="index">
                <div class="">
                  <img :src="item.url" />
                  <p>{{item.icodes}}</p>
                </div>

              </li>
            </ul>
            <div class="clearboth"></div>
            <!-- <div @click="tologs()" v-show="benefit_status" class="card_quanyi_detail">查看权益明细</div> -->
          </div>
        </div>
        <div class="tit_pb m_container" style="position:relative;top:-10px;">
          使用规则
        </div>
        <div class="m_container sy_gz">
          <viperUseRules />
          
        </div>
        <div class="haodetail" @click="toorder()">去预约</div>
      </div>
    </div>
  </div>
</template>

<script>
  import viperUseRules from '../subgroup/viperUseRules.vue'
  export default {
    components:{
      'viperUseRules':viperUseRules
    },
    data() {
      return {
        mycardeatil: {},
        loaded: false,
        benefir_obj88: {
          id: 2,
          url: require('../../assets/images/base/lowprice_88.png'),
          icodes: "88元低价预定"
        },
        benefir_objhalf: {
          id: 2,
          url: require('../../assets/images/FLVersion/fl_lowprice.png'),
          icodes: "五折低价预定"
        },
        icolists: [{
            id: 3,
            url: require('../../assets/images/base/unsubscribe_ensure.png'),
            icodes: "安心退订保障"
          },
          {
            id: 4,
            url: require('../../assets/images/base/service_special.png'),
            icodes: "专项服务免费"
          },
          {
            id: 5,
            url: require('../../assets/images/base/brithday_vip.png'),
            icodes: "会员生日福利"
          },
          {
            id: 6,
            url: require('../../assets/images/base/free_88rmb.png'),
            icodes: "精选星级酒店"
          },
        ],
        cards_no: '',
        benefit_status: false
      }
    },
    created() {},
    mounted() {
      this.$loading('加载中');
      this.cardDetail()
    },
    methods: {

      cardDetail() {
        var $this = this;
        var param = {
          token: localStorage.getItem("token"),
          user_cards_id: this.$route.params.id
        }
        var qs = require('qs');
        let url = this.api.userApi.flCardsDetail
        this.axios.post(url, qs.stringify(param), )
          .then((res) => {
            console.log(res)
            if (res.code == 0) {
              res.data.end_dateM = (res.data.end_date).replace(/-/g, '.')
              $this.mycardeatil = res.data
              $this.cards_no = res.data.cards_no
              $this.$loading.close();
              $this.loaded = true
              // benefit_status
              // icolists
              if(res.data.vip_tag == 'B2' || res.data.vip_tag == 'C2'||res.data.vip_tag == 'A2'){
                $this.icolists.unshift($this.benefir_objhalf)
              }else{
                $this.icolists.unshift($this.benefir_obj88)
              }

              if (res.data.vip_tag == 'B1' || res.data.vip_tag == 'C1' || res.data.vip_tag == 'B2' || res.data.vip_tag ==
                'C2') { // && res.data.free_cycle_type==2
                $this.benefit_status = true
              }

            } else {
              $this.$loading.close();
              $this.$toast(res.msg);
            }
          }).catch((error) => {
            console.warn(error)
            $this.$loading.close();
            // $this.$toast('error');
          })
      },
      toorder() {
        this.$router.push({
          name: 'reserve',
          params: {
            cards_no: this.cards_no
          }
        })
      },
      // 查看权益详情
      showVipBenefit(e) {
        // console.log(e)
        // return
        // var url=window.location.href
        // var id=''
        // if(url.indexOf('http://official.unionfit.cn')>=0){
        //   id=this.mycardeatil.sid
        // }else{
        //   id=this.mycardeatil.testid
        // }
        // console

        var type = 0; //3：钻石会员；2、铂金卡；1、金卡

        if (this.mycardeatil.vip_tag == 'A1' || this.mycardeatil.vip_tag == 'A2') {
          type = 1
        } else if (this.mycardeatil.vip_tag == 'B1' || this.mycardeatil.vip_tag == 'B2') {
          type = 2
        } else if (this.mycardeatil.vip_tag == 'C1' || this.mycardeatil.vip_tag == 'C2') {
          type = 3
        } else {
          type = 1
        }


        var disc=''
        if(this.mycardeatil.vip_tag=='A1'||this.mycardeatil.vip_tag=='B1'||this.mycardeatil.vip_tag=='C1'){
          disc='a1'
        }else{
          disc='a2'
        }
        // console.log(type)
        // // type=2
        this.$router.push({
          name: 'vipbenefit',
          params: {
            type: type,
            card_no: this.mycardeatil.cards_no,
            active: e,
            disc:disc,
            stype:'fit'
          }
        })
      },
      // // 前往免费权益明细
      // toBenefitTime(){
      //   this.$router.push({
      //     name:'freebenefittime'
      //   })
      // },
      tologs() {
        console.log(this.mycardeatil)
        var param = {
          cards_no: this.cards_no,
          free_times: this.mycardeatil.free_times
        }
        this.$router.push({
          name: 'freebenefittime',
          params: param
        })
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;

  .carddetail_total_height {
    height: calc(100vh - 100*@vm_base);
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
  }

  .bb_cardDetail {
    padding: 32*@vm_base 32*@vm_base 42*@vm_base 32*@vm_base;

    // border: 1px solid red;
    .bb_cardDetail_block {
      position: relative;
      width: 100%;

      img {
        width: 100%;
      }

      .bb_cardDetail_block_item_block {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        padding: 45*@vm_base 40*@vm_base;

        .bb_cardDetail_block_item_block_title {
          height: 70*@vm_base;
          line-height: 70*@vm_base;
          font-size: 42*@vm_base;
          font-weight: 600;
          color: rgba(255, 255, 255, 1);
        }

        .bb_cardDetail_block_item_block_mg3 {
          width: 100%;
          height: 56*@vm_base;
          line-height: 56*@vm_base;
          font-size: 28*@vm_base;
          font-weight: 400;
          margin-top: 90*@vm_base;
          color: rgba(255, 255, 255, 1);

          div {
            float: right;
          }
        }

        .bb_cardDetail_block_item_block_mg1 {
          width: 100%;
          height: 44*@vm_base;
          line-height: 44*@vm_base;
          font-size: 24*@vm_base;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);

          div {
            float: right;
          }
        }

        .bb_cardDetail_block_item_block_mg2 {
          width: 100%;
          height: 44*@vm_base;
          line-height: 44*@vm_base;
          font-size: 24*@vm_base;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.5);

          div {
            float: right;
          }
        }
      }
    }
  }

  .bb_cardRightDetail {
    display: flex;
    font-size: 24*@vm_base;
    font-weight: 500;
    color: #000000;
    height: 24*@vm_base;
    line-height: 24px;
    padding: 0 32*@vm_base 0 31*@vm_base;
    // border: 1px solid red;
    margin: 0 auto;
    justify-content: center;
    align-items: center;

    .bb_cardRightDetail_icon {
      width: 21*@vm_base;
      margin-right: 8*@vm_base;
    }

    .bb_cardRightDetail_to {
      width: 10*@vm_base;
      margin-left: 12*@vm_base;
    }
  }

  .myCardDetail_benefits_times {
    padding: 16*@vm_base 32*@vm_base 0 32*@vm_base;
    width: 100%;
    font-size: 36*@vm_base;
    font-weight: 500;
    color: #333333;
    line-height: 36*@vm_base;

    div {
      // width: 175px;
      // height: 28px;
      font-size: 28*@vm_base;
      font-weight: 400;
      color: #3678E1;
      line-height: 36*@vm_base;
      float: right;
    }
  }

  .m_container_fluid {
    width: 100%;
    height: auto;
    overflow: hidden;
    padding: 0 32*@vm_base;
    // border: 1px solid red;
    // border: 1px solid red;
  }

  .m_container {
    width: 100%;
    height: auto;
    overflow: hidden;
    margin: 0 auto;
  }

  .card_quanyi {
    padding-bottom: 70*@vm_base;
    box-shadow: 0px 10*@vm_base 20*@vm_base 0px rgba(238, 238, 238, 1);
    border-radius: 12*@vm_base;
    margin-top: 28*@vm_base;

    .no_benefit_txt_color {
      color: #C7C6CC;
    }
  }

  .card_quanyipad {
    padding-bottom: 32*@vm_base;
  }

  .card_quanyi ul li img {
    display: inline-block;
    width: 72*@vm_base;
    margin-top: 44*@vm_base;
  }

  .card_quanyi ul li {
    float: left;
    text-align: center;
    width: 33.3%;
  }

  .card_quanyi {
    background: #fff;
  }

  .card_quanyi ul li p {
    font-size: 24*@vm_base;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 24*@vm_base;
    margin-top: 24*@vm_base;
  }

  .card_quanyi_single_p {
    color: #c7c6cc;
  }

  .tit_pb {
    font-size: 36*@vm_base;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    // margin-top: 80*@vm_base;
    // margin-bottom: 40*@vm_base;
    padding: 80*@vm_base 32*@vm_base 24*@vm_base 32*@vm_base;
  }

  .sy_gz {
    background: rgba(255, 255, 255, 1);
    overflow: auto;
    box-shadow: 0px 10*@vm_base 20*@vm_base 0px rgba(238, 238, 238, 1);
    border-radius: 12*@vm_base;
    width: calc(100% - 64*@vm_base);
    margin-left: 32*@vm_base;
  }



  

  .haodetail {
    width: 686*@vm_base;
    height: 90*@vm_base;
    border: none;
    outline: none;
    margin-top: 32*@vm_base;
    margin-bottom: 32*@vm_base;
    background-color: #444054;
    border-radius: 12*@vm_base;
    color: #FFFFFF;
    line-height: 90*@vm_base;
    text-align: center;
    font-size: 32*@vm_base;
    margin-left: 32*@vm_base;
  }

  .card_quanyi_detail {
    // float: lef;
    width: 300*@vm_base;
    font-size: 28*@vm_base;
    font-weight: 400;
    color: #3678E1;
    padding: 10*@vm_base 20*@vm_base;
    // border: 1px solid red;
    margin: 0 auto;
    text-align: center;
    margin-top: 36*@vm_base;
    border-radius: 32*@vm_base;
    background: rgba(54, 120, 225, 0.1);
  }
</style>



// WEBPACK FOOTER //
// src/components/myCard/myCardDetail.vue